///////////////////////////////////////////////////////////////////////////////////////////////////
// bau sale this code run on BAU Time When we are use normal buissness (15% Offer)
///////////////////////////////////////////////////////////////////////////

function applyCartLevelDiscount() {
  const wrappers = document.querySelectorAll(".cart-item__price-wrapper");
  if (!wrappers.length) return;

  // 2. grab elements (HTMLCollection)
  const promoCodeTag = document.getElementsByClassName("promo-code-tag")[0];
  // 3. check existence
  // if (!elems || elems.length === 0) {
  //   console.warn('No element found with class .promo-code-tag');
  //   return;
  // }

  let cartTotal = 0;
  let nonComboTotal = 0;
  const items = [];
  let hasComboProduct = false;
  let hasNonComboProduct = false;
  let savingAmount = 0;

  wrappers.forEach((wrapper) => {
    const cartItem = wrapper.closest(".cart-item");
    if (!cartItem || wrapper.closest(".cart_offer_product_wrap")) return;

    const productType =
      cartItem.getAttribute("data-product-type")?.trim().toLowerCase() || "";
    const productwape =
      cartItem.getAttribute("data-product-line")?.trim().toLowerCase() || "";
    let originalPrice = wrapper.getAttribute("data-original-price");

    if (!originalPrice) {
      const priceEl =
        wrapper.querySelector(".original_line_price") ||
        wrapper.querySelector(".price");
      if (!priceEl) return;

      originalPrice = priceEl.textContent.replace(/[^0-9.]/g, "");
      wrapper.setAttribute("data-original-price", originalPrice);
    }

    const totalPrice = parseFloat(originalPrice);
    if (isNaN(totalPrice) || totalPrice <= 0) return;

    // cartTotal += totalPrice;
    //     //checking swap_line_item exit than total will exxlude the swap_line_item total price
    if (productwape != "swap_line_item") {
      cartTotal += totalPrice;
    }

    const isCombo = productType === "combo";
    if (isCombo) {
      hasComboProduct = true;
    } else {
      hasNonComboProduct = true;
      nonComboTotal += totalPrice;
    }

    items.push({
      wrapper,
      totalPrice,
      isCombo,
      productwape,
    });
  });

  let comboDiscount = 0;
  let nonComboDiscount = 0;

  if (hasComboProduct && hasNonComboProduct) {
    // Mixed cart (combo + non-combo)
    comboDiscount = 25;
    nonComboDiscount = cartTotal >= 999 ? 20 : 15;
  } else {
    // Only combo or only non-combo
    if (hasComboProduct) {
      comboDiscount = 25;
    }

    if (hasNonComboProduct) {
      nonComboDiscount = cartTotal >= 999 ? 20 : 15;
    }
  }

  items.forEach(({ wrapper, totalPrice, isCombo, productwape }) => {
    const formatPrice = (price) => `₹${price.toLocaleString("en-IN")}`;
    const discountPercent = isCombo ? comboDiscount : nonComboDiscount;

    if (discountPercent === 0) {
      wrapper.innerHTML = `<span class="original_line_price">${formatPrice(
        totalPrice
      )}</span>`;
    } else {
      const discountedTotal = Math.floor(
        totalPrice * (1 - discountPercent / 100)
      );

      // calculate saving amount
      if (productwape != "swap_line_item") {
        savingAmount += Math.floor(totalPrice - discountedTotal);
      }

      wrapper.innerHTML = `
        <div class="cart-item__discounted-prices">
          <s class="cart-item__old-price price price--end">${formatPrice(
            totalPrice
          )}</s>
          <span class="price price--end">${formatPrice(discountedTotal)}</span>
        </div>
      `;
    }
  });

  // update total saving
  // console.log("savingAmount", savingAmount);

  if (promoCodeTag) {
    promoCodeTag.textContent = `You saved ₹${savingAmount}`;
  } else {
    console.warn("Element with class .promo-code-tag not found!");
  }
}

// Optional: Reset discount if needed
function removeDiscountFrom(wrapper) {
  const original = wrapper.getAttribute("data-original-price");
  if (original) {
    wrapper.innerHTML = `<span class="original_line_price">₹${parseFloat(
      original
    ).toLocaleString("en-IN")}</span>`;
  }
}


// Init logic
document.addEventListener("DOMContentLoaded", function () {
  const applyWithDelay = () => setTimeout(applyCartLevelDiscount, 200);

  applyCartLevelDiscount();

  // Listen to quantity changes
  document
    .querySelectorAll(".quantity__input")
    .forEach((input) => input.addEventListener("change", applyWithDelay));
  document
    .querySelectorAll(".quantity__button")
    .forEach((btn) => btn.addEventListener("click", applyWithDelay));


  // Watch for dynamic cart changes
  const target = document.querySelector(
    ".cart-items, #CartDrawer, .cart-drawer"
  );
  if (target) {
    const observer = new MutationObserver(async () => {
      //checking the swap item available into the sessionstorage than removed

      if (sessionStorage.getItem("swap_parentVariantId")) {
        document
          .querySelectorAll(".test_cdw,#CartDrawer-Item-text_swaper_t")
          .forEach((el) => el.remove());
      }

      //checking the swap item available into the sessionstorage than removed
      applyWithDelay();
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }
});
// end bau sale Apply discount on initial load
